import React from 'react';
import MasterRouter from './masterRouter';

// (опційно) тут можна підключити MUI ThemeProvider / CssBaseline якщо треба
export default function App() {
    return <MasterRouter />;
}
